import React, {Component} from "react";

class Timer extends Component {
	state = {
		hours   : 0,
		minutes : 0,
		seconds : 0
	};

	componentDidMount() {
		this.timerId = setInterval(this.tick.bind(this), 50);
	}

	componentWillUnmount() {
		clearInterval(this.timerId);
	}

	tick() {
		const d = new Date();
		const utc = d.getTime() + (d.getTimezoneOffset() * 60000);
		const date = new Date(utc + (3600000 * 5));

		this.setState({
			hours   : date.getHours() < 10 ? `0${date.getHours()}` : date.getHours(),
			minutes : date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes(),
			seconds : date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds()
		});
	}

	render() {
		return (
			<div className="topmenu__service-time">
				<i className="far fa-clock"></i>&nbsp;
				<span>{this.state.hours}:{this.state.minutes}:{this.state.seconds}</span>
			</div>
		);
	}
}

export default Timer;


// WEBPACK FOOTER //
// ./src/app/components/Timer.js